export const iconMapping = {
  1: "fa-car", // Parking
  2: "fa-couch", // Lounge
  6: "fa-building", // Business Hotel/Meeting Rooms
  7: "fa-money-bill-wave", // Currency Exchange
  8: "fa-glass-martini-alt", // Bar
  11: "fa-tv", // Television
  12: "fa-tshirt", // Laundry
  13: "fa-swimming-pool", // Swimming Pool
  14: "fa-utensils", // Restaurant
  16: "fa-wifi", // Wi-Fi/Internet
  17: "fa-dumbbell", // Gym
  20: "fa-sun", // Balcony/Terrace
  24: "fa-concierge-bell", // Room Service
  30: "fa-briefcase-medical", // Medical
  32: "fa-lock", // Safety Deposit Box
  49: "fa-user-tie", // Concierge Services
  59: "fa-snowflake", // Air Conditioning
  78: "fa-coffee", // Tea and Coffee Facilities
  79: "fa-child", // Children's Club
  0: "fa-star", // Default/General
};
